import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { resetStore, prevStep, nextStep, checkLastStep } from 'store/actions';
import { handleResult } from 'shared/decision';

import store from 'store';

import Analytics from '../../utils/analytics';

const mapStateToProps = (state) => ({
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  resetStore: () => dispatch(resetStore()),
  prevStep: () => dispatch(prevStep()),
  nextStep: () => dispatch(nextStep()),
  checkLastStep: () => dispatch(checkLastStep())
});

class StepperNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideExitBtn: false
    };
  }

  componentDidMount() {
    // Hide exit button if div#app has data-hide-exit-btn attribute
    this.setState({hideExitBtn: document.getElementById('app').hasAttribute("data-hide-exit-button")});
  }

  handleNextStepClick = (currentStep) => {
    if (this.props.onCLickNext) {
      this.props.onCLickNext();
    }
    this.props.nextStep();
  }

  handlePrevStepClick = (step) => {
    const { t, resetStore, prevStep, checkLastStep } = this.props;
    let previousStep;

    if (step !== 1) {

      previousStep = step - 1;

      Analytics.pushData({
        eventCategory: 'recomendador starressa',
        eventAction: 'clic volver_paso',
        eventLabel: `volver_paso_${previousStep}`
      });
      prevStep();
    } else {
      resetStore();

      // If last url was in same domain
      if (document.referrer.indexOf(document.location.origin) !== -1) {
        window.history.back();
      }

      // If history back didn't work
      window.location = t('sourceUrl');
    }

    checkLastStep();
  }

  handleResultClick = () => {
    const { survey } = this.props;

    if (this.props.onCLickNext) {
      this.props.onCLickNext();
    }

    handleResult(survey);
  }

  render() {
    const { t, hideNextBtn, disableNextBtn, showResultBtn } = this.props;

    const currentStep = store.getState().step
    const backBtnText = currentStep === 1 ? t('common.exit') : t('common.go_back');

    return (
      <div className="c-stepper-nav">
        {
          ((this.state.hideExitBtn && currentStep !== 1) || !this.state.hideExitBtn) && (
            <button type="button" className="e-button e-button--fake-link" onClick={() => this.handlePrevStepClick(currentStep)}>
              <span className="c-stepper-nav__icon-back icon-arrow-back" /> {backBtnText}
            </button>
          )
        }
        {!hideNextBtn && !showResultBtn && (
          <button type="button" className="e-button e-button--primary" disabled={disableNextBtn} onClick={() => this.handleNextStepClick()}>{t('common.continue')}</button>
        )}
        {showResultBtn && (
          <button type="button" className="e-button e-button--primary" disabled={disableNextBtn} onClick={() => this.handleResultClick()}>{t('common.result')}</button>
        )}
      </div>
    );
  }
}

const ConnectedStepperNav = connect(mapStateToProps, mapDispatchToProps)(StepperNav);
export default withTranslation('translations')(ConnectedStepperNav);
